import { render } from "./EditingGeneral.vue?vue&type=template&id=0e06e196&scoped=true"
import script from "./EditingGeneral.vue?vue&type=script&lang=js"
export * from "./EditingGeneral.vue?vue&type=script&lang=js"

import "./EditingGeneral.vue?vue&type=style&index=0&id=0e06e196&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e06e196"

export default script